import { appPromo } from '@/mocks/homeData';

export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">移动观影</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">{appPromo.title}</h2>
            <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-lg mx-auto lg:mx-0">{appPromo.subtitle}</p>

            <div className="grid grid-cols-2 gap-4 max-w-md mx-auto lg:mx-0 mb-8">
              {appPromo.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-3 p-3 rounded-xl bg-background-50">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${feat.icon} text-accent-600 text-base`}></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{feat.text}</span>
                </div>
              ))}
            </div>

            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-download-2-line"></i>
              立即体验移动端
            </a>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative">
              <div className="absolute -inset-8 bg-primary-200/20 rounded-[3rem] blur-3xl"></div>
              <img
                src={appPromo.image}
                alt="88影视网移动端高清在线观看"
                className="relative w-56 md:w-64 h-auto rounded-[2rem] shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}